import { combineReducers } from "redux";
import { currentConversation } from "./reducers/currentConversation";
import { conversations } from "./reducers/conversations";
import { recipients } from "./reducers/recipients";
import uiReducer from "./dux/ui/reducer";
export default combineReducers({
  config: (state = {}) => state,
  conversations,
  current_user: (state = {}) => state,
  currentConversation,
  groups: (state = {}) => state,
  categories: (state = []) => state,
  organization: (state = {}) => state,
  recipients,
  ui: uiReducer
});
